import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import useWindowTools from "../../react-hooks/useWindowTools";
import layoutState from "../../shared-services/globalState/layoutState";
import useImageLoadWatch from "./useImageLoadWatch";

const useMainContainerBoundaries = (props) => {
  const topBoundaryElements = [".category_header_component", "#categories-header"];
  const bottomBoundaryElements = ["footer"];
  const timeoutMs = 200;

  const {scrollPosition} = useWindowTools();
  const location = useLocation();
  const {imagesLoadComplete} = useImageLoadWatch();

  const {
    mainContainerBoundaries: initialBoundaries,
    setMainContainerBoundaries
  } = layoutState();

  const [boundaries, setBoundaries] = useState(initialBoundaries);
  const [currentTimeout, setCurrentTimeout] = useState(null);

  const setValues = () => {
    const newTopPosition = Math.max(
      ...topBoundaryElements.map(selector => {
        return document.querySelector(selector)?.getBoundingClientRect()?.bottom || 0;
      })
    );

    let newBottomPosition = Math.min(
      ...bottomBoundaryElements.map(selector => {
        let bottom = document.querySelector(selector)?.getBoundingClientRect()?.top;
        bottom = bottom || 0;
        if (bottom < 0) bottom = 0;

        return bottom;
      })
    );

    if (newBottomPosition < 0) newBottomPosition = 0;

    const shouldUpdate = (newTopPosition && newTopPosition !== boundaries?.topPosition) ||
      (newBottomPosition && newBottomPosition !== boundaries?.bottomPosition);

    if (shouldUpdate) {
      const newBoundaries = {topPosition: newTopPosition, bottomPosition: newBottomPosition};
      setBoundaries(newBoundaries);
      setMainContainerBoundaries(newBoundaries);
    }
  };

  const deferSetValues = () => {
    if (currentTimeout) clearTimeout(currentTimeout);

    setCurrentTimeout(setTimeout(() => requestAnimationFrame(setValues), timeoutMs));
  };

  useEffect(() => {
    deferSetValues();
  }, [scrollPosition, location]);

  useEffect(() => {
    if (imagesLoadComplete) deferSetValues();
  }, [imagesLoadComplete]);

  useEffect(() => {
    setValues();
  }, []);

  return {boundaries};
};

export default useMainContainerBoundaries;
